<template>
  <svg width="172" height="140" viewBox="0 0 172 140" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M103.5 56.7682V66.5853M103.5 66.5853H125.695M103.5 66.5853H94.9636C93.5492 66.5853 92.4026 65.4387 92.4026 64.0243V52.0731C92.4026 44.5297 98.5177 38.4146 106.061 38.4146H123.134C130.678 38.4146 136.793 44.5297 136.793 52.0731V64.0243C136.793 65.4387 135.646 66.5853 134.232 66.5853H125.695M125.695 66.5853V56.7682M127.829 19.6341C127.829 26.706 122.096 32.439 115.025 32.439C107.953 32.439 102.22 26.706 102.22 19.6341C102.22 12.5622 107.953 6.82922 115.025 6.82922C122.096 6.82922 127.829 12.5622 127.829 19.6341Z"
      :stroke="color"
      stroke-width="3.41463"
      stroke-linecap="round"
    />
    <path
      d="M37.7681 26.8903C36.8252 26.8903 36.0608 27.6546 36.0608 28.5976V34.5732C36.0608 35.5161 36.8252 36.2805 37.7681 36.2805H48.012H58.2559C59.1988 36.2805 59.9632 35.5161 59.9632 34.5732V28.5976C59.9632 27.6547 59.1988 26.8903 58.2559 26.8903H37.7681Z"
      :fill="color"
    />
    <path
      d="M66.7925 50.7927H62.951C62.0081 50.7927 61.2437 50.0283 61.2437 49.0854V45.2439C61.2437 44.301 60.4793 43.5366 59.5364 43.5366H48.012M66.7925 50.7927V39.2683L69.7803 43.1098L71.9144 39.2683L73.6218 43.1098L77.0364 39.2683V50.7927M66.7925 50.7927H77.0364M77.0364 50.7927H78.3169C79.2598 50.7927 80.0242 51.5571 80.0242 52.5V65.3049C80.0242 66.2478 79.2598 67.0122 78.3169 67.0122H37.7681C36.8252 67.0122 36.0608 66.2478 36.0608 65.3049V45.2439C36.0608 44.301 36.8252 43.5366 37.7681 43.5366H48.012M48.012 36.2805H58.2559C59.1988 36.2805 59.9632 35.5161 59.9632 34.5732V28.5976C59.9632 27.6547 59.1988 26.8903 58.2559 26.8903H37.7681C36.8252 26.8903 36.0608 27.6546 36.0608 28.5976V34.5732C36.0608 35.5161 36.8252 36.2805 37.7681 36.2805H48.012ZM48.012 36.2805V43.5366"
      :stroke="color"
      stroke-width="2.56098"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.8292 78.5365H14.2927C12.8783 78.5365 11.7317 77.39 11.7317 75.9756V69.1463C11.7317 67.7319 12.8783 66.5853 14.2927 66.5853H158.134C159.549 66.5853 160.695 67.7319 160.695 69.1463V75.9756C160.695 77.39 159.549 78.5365 158.134 78.5365H150.451M22.8292 78.5365V117.805M22.8292 78.5365H150.451M22.8292 117.805H11.7317M22.8292 117.805H150.451M150.451 78.5365V117.805M150.451 117.805H160.695M58.6829 107.561H114.171C115.585 107.561 116.732 106.414 116.732 105V91.3414C116.732 89.927 115.585 88.7804 114.171 88.7804H58.6829C57.2685 88.7804 56.1219 89.927 56.1219 91.3414V105C56.1219 106.414 57.2685 107.561 58.6829 107.561Z"
      :stroke="color"
      stroke-width="3.41463"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'CashierSvg',
  props: {
    color: {
      type: String,
      default: '#000000'
    }
  }
}
</script>

<style lang="scss" scoped></style>
